import { render } from "./ReCreateOrder.vue?vue&type=template&id=44c32799"
import script from "./ReCreateOrder.vue?vue&type=script&lang=js"
export * from "./ReCreateOrder.vue?vue&type=script&lang=js"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__